const images = {
  logo: require('./logo.png'),
  circleLogo:require('./circle_logo.png'),
  whiteLogo:require('./logo.png'),
  logoTMW: require('./logo.png'),
  aia_logo: require('./aia_logo.png'),
  omwa_dialog_logo: require('./omwa-dialog-image.png'),
}

export default images